import { serializable, alias, primitive } from 'serializr';

export class ChildProduct {
  @serializable(alias('id'))
  commodityId?: number;

  @serializable(alias('unique_id'))
  uniqueId?: string;

  @serializable
  name?: string;

  @serializable(alias('is_new'))
  isNew?: boolean;

  @serializable
  b2c?: number;

  @serializable(alias('brand_name'))
  brandName?: string;

  @serializable
  stage?: number;

  @serializable(alias('reporting_period'))
  reportingPeriod?: string;

  @serializable(alias('processing_facility'))
  processingFacilityName?: string;

  @serializable(alias('commodity_type'))
  commodityType?: string;

  @serializable
  status?: string;

  @serializable
  image?: string;

  @serializable(alias('livestock_category', primitive()))
  livestockCategory?: string;
}
